module.exports = __webpack_public_path__ + "static/media/office_status.0ce70879.svg";